import classnames from 'classnames';
import React, { ReactNode } from 'react';

import {
	container as containerStyle,
	large as largeStyle,
	wideChildren as wideChildrenStyle,
	wideTitle as wideTitleStyle,
} from './style.module.css';

export interface FeatureTitleProps {
	title1?: string | null;
	title2?: string | null;
	subtitle?: string | null;
	large?: boolean;
	children?: ReactNode;
	wideChildren?: boolean;
	wideTitle?: boolean;
}

export const FeatureTitle = ({
	title1,
	title2,
	subtitle,
	large = false,
	wideChildren = false,
	wideTitle = false,
	children,
}: FeatureTitleProps): JSX.Element => {
	return (
		<section
			className={classnames(containerStyle, large && largeStyle, wideChildren && wideChildrenStyle)}
		>
			{!!title1 && <h2>{title1}</h2>}
			{!!title2 && <h1 className={classnames(wideTitle && wideTitleStyle)}>{title2}</h1>}
			{!!subtitle && <h3>{subtitle}</h3>}
			{children}
		</section>
	);
};
